import React, { ComponentProps } from 'react';
import { Button, Icon } from '@common/components';

export function ExportButton({
  children,
  ...props
}: Omit<ComponentProps<typeof Button>, 'icon' | 'iconRight'>) {
  return (
    <Button
      {...props}
      size="md"
      icon={<Icon icon="fileExport" size="md" kind="light" />}
    >
      {children}
    </Button>
  );
}
